import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ImportSettingsService } from '../../../import-settings/import-settings.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ImportTemplateService } from '../../import-template.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';


declare const XLSX: any;
declare const moment: any;


@Component({
  selector: 'app-charge-files',
  templateUrl: './charge-files.component.html',
  styleUrls: ['./charge-files.component.scss']
})
export class ChargeFilesComponent implements OnInit, OnChanges {

  public data = [];
  public dataForm: any;
  public onLoadData: boolean;
  public fileName:  any;
  public fileExcel: any;
  public fileCsv: any;
  public separator: string;
  public valueData: boolean;
  public importType: any;
  public rules: any;
  public entity: any;
  public separators = [{value: ',', row: 'coma'} , {value: '.', row: 'point'}, {value: ' ', row: 'space'}];
  public form: FormGroup;
  public showSetting = false;
  public next1 = true;
  public next2 = false;
  public validatedForm= false;
  public entityData = [];
  public headboardData = [];

  @Input() cancelInput: any;
  @Output() selectedFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitNextForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitViewFile = new EventEmitter<any>();
  @ViewChild('fileInputData')fileInputData: ElementRef;

  constructor(
    private _ImportSetting: ImportSettingsService,
    private fb: FormBuilder,
    private renderer: Renderer,
    private _Import: ImportTemplateService,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
    this.getSetting();
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cancelInput']) {
      if (changes['cancelInput'].currentValue === true) {
        this.cancelForm();
      }
    }
  }

  /**
   * @Metodo createForm
   * @description Para crear el formulario
   * */
  createForm() {
    this.form = this.fb.group({
      sourceColumns: [[], [Validators.required]],
      staticConfig: this.fb.group({
        importType: ['', [Validators.required]],
        fileType: ['', [Validators.required]],
        delimiter: null,
        firstRowIsColumn: ['', [Validators.required]]
      }),
      dynamicConfig: ['', [Validators.required]]
    });
    this.form.controls['staticConfig'].disable();
    this.getSelectForm();
  }

  /**
   * @Metodo getSetting
   * @description Para traer json de configuración
   * */
  getSetting() {
    this._ImportSetting.getAllRulesImports()
      .subscribe(success => {
        this.importType = success;
        this.parseImporType(this.importType);
      });
  }
  /**
   * @Metodo normalizeKye
   * @description Para realizar cambios a los string de la cabecera
   * */
  normalizeString (value) {
    const head = [];
    value.forEach((val, i) => {
      head[i] = val.toLowerCase();
    });
    this.headboardData[0] = head;
    // return (typeof value === 'string') ? normalize(value) : value;
    const space = / /gi;
    const characters = /ï»¿/g;
    value.forEach( row => {
      const one = row.replace(space, '');
      const tow = one.replace(characters, '');
      this.data.push(tow);
    });
  }

  /**
   * @Metodo normalizeValue
   * @description para darle formato a las fechas del documento.
   * */
  normalizeDate (value) {
    if (value instanceof Date) {
      return moment(value).format('DD-MM-YYYY');
    }
    return (typeof value === 'string') ? value.trim() : value;
  }

  /**
   * @Metodo fileUp
   * @description para cargar archivo segun tipo
   * */
  fileUp(event: any) {
    this.deleteData();
    this.deletFilesdata();
    this.form.controls['staticConfig'].enable();
    this.getstatic().controls['delimiter'].reset();
    this.fileName = event.target.files[0].name;
    const exten = this.fileName.substr(-6);
    if (
      exten.split('.')[1] === 'xlsx' ||
      exten.split('.')[1] === 'xls'
    ) {
      this.form.patchValue({
        staticConfig: {
          fileType: 'xlsx',
          firstRowIsColumn: true,
          delimiter: null
        }
      });
      this.getstatic().controls['delimiter'].disable();
      this.convertFileExcel(event);
      this.getstatic().controls['importType'].enable();
      this.getstatic().controls['delimiter'].setValidators([]);
      this.getstatic().controls['delimiter'].updateValueAndValidity();
      this.fileExcel = event;
    }else
    if (exten.split('.')[1] === 'csv') {
      this.form.patchValue({
        staticConfig: {
          delimiter: null,
          fileType: 'csv',
          firstRowIsColumn: true
        }
      });
      this.fileCsv = event;
      this.getstatic().controls['importType'].disable();
      this.getstatic().controls['delimiter'].setValidators([Validators.required]);
      this.getstatic().controls['delimiter'].updateValueAndValidity();
    } else {
      this.form.controls['staticConfig'].disable();
      this.sweetAlertHelper.createCustomAlert({
          title: 'File',
          type: 'warning',
          text: 'Select a Document valid'
        }
      );
    }
    this.renderer.setElementAttribute(this.fileInputData.nativeElement, 'value', 'null');
    this.viewFileChage(event.srcElement.files);
  }

  /**
   * @Metodo deletFilesdata
   * @description
   * */
  deletFilesdata() {
    this.fileExcel = null;
    this.fileCsv = null;
  }

  /**
   * @Metodo convertFileExcel
   * @description para cargar la cabecera y convertir archivo excel
   * */
  convertFileExcel(event) {
    // this.fileInput;
    this.fileName = event.target.files[0].name;
    /* para cargar el archivo  */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* leer el archivo en binario */
      const bstr: string = e.target.result;
      const wb = XLSX.read(bstr, {type: 'binary'});

      /* carga la primera hoja para el heder en string*/
      const wsname: string = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      /* Salvo los datos */
      const totalFiles = (XLSX.utils.sheet_to_json(ws, {header: 1}));

      this.normalizeString(totalFiles[0]);
      // this.starViewFile(totalFiles);
    };
    reader.onloadend = (e) => {
      this.form.patchValue(
        { sourceColumns: this.data}
      );
    };
    reader.readAsBinaryString(target.files[0]);
  }

  /**
   * @Metodo starViewFile
   * @description para cargar archivo en la vista
   * */
  starViewFile(dataFile: any[], separator?) {
    const characters = /ï»¿/g;
    dataFile.splice(10);
    if (typeof dataFile[0] === 'string') {
      dataFile.forEach( (val, i ) => {
        // const row = val.split(',');
        /*row.forEach( (e, x) => {
          row[x] = e.replace(characters, '');
        });
        this.viewFile[i] = row;*/
        if (val.includes('"')) {
          val = this.normalizeValues(val);

        }
      });
    }
    /*const space = / /gi;
    const characters = /ï»¿/g;
    value.forEach( row => {
      const one = row.replace(space, '');
      const tow = one.replace(characters, '');*/

  }
   normalizeValues(val) {
    const value = '';
    if (val.includes('"')) {
      val[val.indexOf(',', val.indexOf('"'))] = ' ';
    }
    return value;
   }

  /**
   * @Metodo convertFileCsv
   * @description para cargar la cabecera y convertir archivo Csv
   * */
  convertFileCsv(csv, separator: string) {
    const target = <DataTransfer>(csv.target);
    if (target.files.length !== 1) {throw new Error('Cannot use multiple files'); }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const linesFile = bstr.split('\n');
      const line = linesFile[0].split(separator);
      this.normalizeString(line);
      // this.starViewFile(linesFile);
    };
    reader.onloadend = (e) => {
      this.form.patchValue(
        { sourceColumns: this.data}
      );
    };
    reader.readAsBinaryString(target.files[0]);
  }


  /**
   * @Metodo getValue
   * @description para pasar los Datos del form
   * */
  getValue(): any {
    const dataConfic = this.form.getRawValue();
    return dataConfic;
  }

  /**
   * @Metodo parseImporType
   * @description para parsear la repuesta a Json
   * */
  parseImporType(setting) {
    setting.forEach(row => {
      row.entitysetting = JSON.parse(row.entitysetting);
      row.rulesetting = JSON.parse(row.rulesetting);
    });
  }

  /**
   * @Metodo selectRules
   * @description para escuchar el formulario y los campos
   * */
  getSelectForm() {
    this.form.valueChanges.subscribe(val => {this.validNext(val); });
    this.getstatic().controls['importType'].valueChanges
      .subscribe(val => {
        if (val) {
          this.importType.forEach(row => {
            if (val === row.importtypeid) {
              this.dataForm = row.rulesetting;
              // this.rules = row.rulesetting;
              this.entity = row.entitysetting.rules;
              this.form.controls['dynamicConfig'].setValue('');
            }
          });
          this.showSetting = true;
        }
    });
    this.getstatic().controls['delimiter'].valueChanges
      .subscribe( val => {
        if (val) {
          this.convertFileCsv(this.fileCsv, val);
          this.getstatic().controls['importType'].enable();
        }
    });
    this.getstatic().controls['firstRowIsColumn'].valueChanges
      .subscribe(val => {
        this.changeHeader(val);
      });
  }

  /**
   * @Metodo cancelForm
   * @description para cancelar lo llenado en el form
   * */
  cancelForm() {
    this.form.reset();
    this.deleteData();
    this.fileName = '';
    this.showSetting = false;
    this.form.controls['staticConfig'].disable();
    this.fileCsv = undefined;
    this.fileExcel = undefined;
  }

  /**
   * @Metodo getstatic
   * @description para devolver el control Group staticConfig
   * */
  getstatic(): FormGroup {
    return this.form.get('staticConfig') as FormGroup;
  }

  /**
   * @Metodo validNext
   * @description valida que el formulario este valid y emite
   * */
  validNext(event) {
    if (this.form.valid) {
        this.entityData = [this.entity, event.sourceColumns, event.staticConfig.importType];
      const formEmit = {
        sourceColumns: event.sourceColumns,
        settings: {
          staticConfig: event.staticConfig,
          dynamicConfig: event.dynamicConfig
        }
      };
      this.validatedForm = true;
      this.emitNextForm.emit(formEmit);
      this.selectedFile.emit(this.entityData);
      this.emitViewFile.emit(this.headboardData);
    }else {this.emitNextForm.emit(false); }
  }

  /**
   * @Metodo changeHeader
   * @description modifica el Header
   * */
  changeHeader(val) {
    const heaRow = [];
    const type = this.form.controls['staticConfig'].get('importType').value;
    if (val === false) {
    if (this.form.valid) {
      this.data.forEach((row, i) => {heaRow.push(i); });
      this.form.patchValue({sourceColumns: heaRow});
      const value = this.getValue();
      this.validNext(value);
    } else {
      this.data.forEach((row, i) => {heaRow.push(i); });
      this.form.patchValue({sourceColumns: heaRow});
    }
    }else {
      if (this.entityData.length) {
        if (this.form.valid) {
        this.entityData = [this.entity, this.data, type];
        this.selectedFile.emit(this.entityData);
        }
      }
    }
  }

  /**
   * @Metodo viewFileChage
   * @description para visualizar documento.
   * */
  viewFileChage(data) {
    this._Import.postFile(data)
      .subscribe(success => {
        this.headboardData[1] = success;
    });
  }

  /**
   * @Metodo deleteData
   * @description Borra los datos del array para que no ocupen espacio en memoria.
   * */
  deleteData() {
    const num = this.data.length;
    this.data.splice(1, num);
  }



}




// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/charge-files/charge-files.component.ts